import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLFormElement> {
  private handler = (e: KeyboardEvent): void => this.handleKeydown(e)

  connect(): void {
    window.addEventListener("keydown", this.handler)
  }

  disconnect(): void {
    window.removeEventListener("keydown", this.handler)
  }

  private handleKeydown(e: KeyboardEvent): void {
    const modifier = e.metaKey || e.ctrlKey
    if (modifier && e.key.toLowerCase() === "s") {
      e.preventDefault()
      this.element.requestSubmit()
    }
  }
}
